declare let THREE: any;

export class ObjectWorldTransform {

  private objectRotationQ = new THREE.Quaternion();
  public readonly position = new THREE.Vector3();
  public readonly rotation = new THREE.Euler();

  setFromObject(object) {
    object.getWorldPosition(this.position);
    object.getWorldQuaternion(this.objectRotationQ);
    this.rotation.setFromQuaternion(this.objectRotationQ);
  }

  copy(transformation: ObjectWorldTransform) {
    this.position.copy(transformation.position);
    this.rotation.copy(transformation.rotation);
    return this;
  }
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/Drag/Class/ObjectWorldTransform.ts